exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".house-ad{margin-left:auto;margin-right:auto;text-align:center}.house-ad img{max-width:100%;width:728px}@media (max-width: 480px){.house-ad img{width:320px}}\n", ""]);

// exports
exports.locals = {
	"house-ad": "house-ad"
};